import ProCard from "@ant-design/pro-card";
import { PageContainer } from "@ant-design/pro-layout";
import { Menu } from "antd";
import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import DepartmentRoleView from "./department-role-view";
import TeamAvailability from "./team-availability";
import ScheduleWeek from "./components/week/week";
import Preferences from "./preferences";
import WeekView from "../../pages/WeekView";
import ScheduleTimelineWrapper from "./components/timeline";

const Schedule = (): JSX.Element => {
  const defaultSelectedKey = "weekNew";
  const [currentTab, setCurrentTab] = useState<string>(defaultSelectedKey);
  const [searchParams, setSearchParams] = useSearchParams();

  const tabQueryToMenuKey: Record<string, string> = {
    week: "weekNew",
    weekNew: "weekNew",
    timeline: "timeline",
    preferences: "preferences",
  };

  const menuKeyToTabQuery: Record<string, string> = {
    weekNew: "week",
    timeline: "timeline",
    preferences: "preferences",
  };

  useEffect(() => {
    const tabFromQuery = searchParams.get("tab") ?? "";
    const resolvedTab = tabQueryToMenuKey[tabFromQuery] ?? defaultSelectedKey;

    if (currentTab !== resolvedTab) {
      setCurrentTab(resolvedTab);
    }

    const normalizedQueryTab = menuKeyToTabQuery[resolvedTab] ?? "week";
    if (tabFromQuery !== normalizedQueryTab) {
      const nextParams = new URLSearchParams(searchParams);
      nextParams.set("tab", normalizedQueryTab);
      setSearchParams(nextParams, { replace: true });
    }
  }, [searchParams, setSearchParams, currentTab]);

  const handleTabChange = (event: { key: string }) => {
    setCurrentTab(event.key);
    const nextParams = new URLSearchParams(searchParams);
    nextParams.set("tab", menuKeyToTabQuery[event.key] ?? "week");
    setSearchParams(nextParams);
  };

  const renderComponent = () => {
    switch (currentTab) {
      case "week":
        return <ScheduleWeek />;
      case "weekNew":
        return <WeekView />;
      case "timeline":
        return <ScheduleTimelineWrapper />;
      case "departmentRoleView":
        return <DepartmentRoleView />;
      case "teamAvailability":
        return <TeamAvailability />;
      case "preferences":
        return <Preferences />;
      default:
        return <WeekView />;
    }
  };

  return (
    <PageContainer
      /*extra={[
        <Button key="3">Operate</Button>,
        <Button key="2">Operate</Button>,
        <Button key="1" type="primary">
          Main Operation
        </Button>,
      ]}*/
      subTitle="Efficiently organize and oversee your schedule along with handling time off requests!"
      /*footer={[
      <Button key="3">Reset</Button>,
      <Button key="2" type="primary">
        Submit
      </Button>,
    ]}*/
    >
      <ProCard>
        <Menu
          onClick={handleTabChange}
          mode="horizontal"
          defaultSelectedKeys={[defaultSelectedKey]}
          selectedKeys={[currentTab]}
        >
          {/*<Menu.Item key="week">
            <span>Week</span>
          </Menu.Item>*/}
          <Menu.Item key="weekNew">
            <span>Week</span>
          </Menu.Item>
          <Menu.Item key="timeline">
            <span>Timeline</span>
          </Menu.Item>
          {/*<Menu.Item key="departmentRoleView">
            <span>Department/Role View</span>
          </Menu.Item>
          <Menu.Item key="teamAvailability">
            <span>Team Availability</span>
          </Menu.Item> */}
          <Menu.Item key="preferences">
            <span>Preferences</span>
          </Menu.Item>
        </Menu>
        {renderComponent()}
      </ProCard>
    </PageContainer>
  );
};

export default Schedule;
